"use strict";
/** This Component can be used to wrap a functional component in order to generate a random ID
 * Example of how to use this component
 *
 * const Component = ({id}: {id: string}) => (
 *  <GenerateId>{randomId => (
 *     <div id={id || randomId}>
 *       div with random ID
 *     </div>
 *   )}
 *  </GenerateId>
 *  );
 */

require("core-js/modules/es6.regexp.to-string");

require("core-js/modules/es6.date.to-string");

require("core-js/modules/es6.object.to-string");

require("core-js/modules/es6.reflect.construct");

var _classCallCheck = require("/home/sam/Desktop/projects/startups/explot/app/node_modules/@babel/runtime/helpers/classCallCheck");

var _createClass = require("/home/sam/Desktop/projects/startups/explot/app/node_modules/@babel/runtime/helpers/createClass");

var _inherits = require("/home/sam/Desktop/projects/startups/explot/app/node_modules/@babel/runtime/helpers/inherits");

var _possibleConstructorReturn = require("/home/sam/Desktop/projects/startups/explot/app/node_modules/@babel/runtime/helpers/possibleConstructorReturn");

var _getPrototypeOf = require("/home/sam/Desktop/projects/startups/explot/app/node_modules/@babel/runtime/helpers/getPrototypeOf");

require("core-js/modules/es6.object.define-property");

function _createSuper(Derived) { var hasNativeReflectConstruct = _isNativeReflectConstruct(); return function _createSuperInternal() { var Super = _getPrototypeOf(Derived), result; if (hasNativeReflectConstruct) { var NewTarget = _getPrototypeOf(this).constructor; result = Reflect.construct(Super, arguments, NewTarget); } else { result = Super.apply(this, arguments); } return _possibleConstructorReturn(this, result); }; }

function _isNativeReflectConstruct() { if (typeof Reflect === "undefined" || !Reflect.construct) return false; if (Reflect.construct.sham) return false; if (typeof Proxy === "function") return true; try { Date.prototype.toString.call(Reflect.construct(Date, [], function () {})); return true; } catch (e) { return false; } }

Object.defineProperty(exports, "__esModule", {
  value: true
});

var tslib_1 = require("tslib");

var React = tslib_1.__importStar(require("react"));

var currentId = 0;

var GenerateId = /*#__PURE__*/function (_React$Component) {
  _inherits(GenerateId, _React$Component);

  var _super = _createSuper(GenerateId);

  function GenerateId() {
    var _this;

    _classCallCheck(this, GenerateId);

    _this = _super.apply(this, arguments);
    _this.id = "".concat(_this.props.prefix).concat(currentId++);
    return _this;
  }

  _createClass(GenerateId, [{
    key: "render",
    value: function render() {
      return this.props.children(this.id);
    }
  }]);

  return GenerateId;
}(React.Component);

exports.GenerateId = GenerateId;
GenerateId.displayName = 'GenerateId';
GenerateId.defaultProps = {
  prefix: 'pf-random-id-'
};